import { configConstants } from '../constants';
import axios from 'axios';
import { history, setHeaders } from 'helpers';

export const masterAdminService = {
   getAdminByID,
   addNewAdmin,
   editAdmin,
   deleteAdmin,
   getListsAdmin,
   getListMerchants,
   editPassword,
   emailPasswordExpire
};

const authFailedRedirectPath = "/auth/login";

function getAdminByID(id) {
   let tmp = axios.get(configConstants.API_BACKEND_CRM + `/merchants/admin/find/${id}`, {
       headers: setHeaders({ 'Charset': 'utf-8' })
   }).then(response => {
           if (response.data.statusCode.toString() === "200") {
               return {
                   status: true,
                   data: response.data.data,
                   message: response.data.message
               };
           } else if (response.data.message === "UNAUTHORIZE") {
               history.push('/auth/login')
               return { status: false, data: {}, message: response.data.message, unAlert: true };
           } else {
               return {
                   status: false,
                   data: {},
                   message: response.data.message
               };
           }
       })
       .catch(e => {
           return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
       });

   return tmp;
}

function addNewAdmin(params) {
   var tmp = axios.post(configConstants.API_BACKEND_CRM + '/merchants/admin', params, { headers: setHeaders() })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            history.push(authFailedRedirectPath)
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })

   return tmp;
}

function editAdmin(params) {
   var tmp = axios.put(configConstants.API_BACKEND_CRM + `/merchants/admin/${params._id}`, params, { headers: setHeaders() })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            history.push(authFailedRedirectPath)
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })

   return tmp;
}

function deleteAdmin(params) {
   var tmp = axios.delete(configConstants.API_BACKEND_CRM + `/merchants/admin/${params._id}`, { headers: setHeaders() })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            history.push(authFailedRedirectPath)
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })

   return tmp;
}

function getListsAdmin(params) {
   var tmp = axios.get(configConstants.API_BACKEND_CRM + `/merchants/admin/find?${params}`, { headers: setHeaders({ 'Charset': 'utf-8' }) })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            history.push(authFailedRedirectPath)
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      });

   return tmp;
}

function getListMerchants() {
   var tmp = axios.get(configConstants.API_BACKEND_CRM + `/merchants/get/lists`, { headers: setHeaders({ 'Charset': 'utf-8' }) })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            history.push(authFailedRedirectPath)
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      });

   return tmp;
}

function editPassword(params) {
   var tmp = axios.put(configConstants.API_BACKEND_CRM + `/merchants/admin/${params._id}/reset`, params, { headers: setHeaders() })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            history.push(authFailedRedirectPath)
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })

   return tmp;
}

function emailPasswordExpire(params) {
   var tmp = axios.post(configConstants.API_BACKEND_CRM + `/merchants/admin/${params.email}/email-reset-password`, params, { headers: setHeaders() })
      .then(response => {
         if (response.data.statusCode.toString() === "200") {
            return { status: true, data: response.data.data, message: response.data.message };
         } else if (response.data.message === "UNAUTHORIZE") {
            return { status: false, data: {}, message: response.data.message, unAlert: true };
         } else {
            return { status: false, data: {}, message: response.data.message };
         }
      }).catch(e => {
         // history.push(authFailedRedirectPath)
         return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
      })

   return tmp;
}